import { Component, OnInit } from '@angular/core';
import { RegisterVM, CountryVM, ReasonForMedicationVM, CounsellingTopicVM } from '../../../models';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupService } from '../../../services/signup.service';
import { ReferenceDataService } from '../../../services/referencedata.service';
import { BaseComponent } from '../../base/base.component';

@Component({
    selector: 'signup-step2',
    templateUrl: './step2.component.html'
})
export class Step2Component extends BaseComponent implements OnInit {

    myModel: RegisterVM;

    constructor(
        private signupService: SignupService,
        private refService: ReferenceDataService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router) {
        super(route);
        this.myModel = signupService.model;
    }

    ngOnInit(): void {
        this.myForm = this.formBuilder.group({
            presentingIssue1: new FormControl('', Validators.required),
            presentingIssue2: new FormControl(''),
            presentingIssue3: new FormControl(''),
            prescribedMedication: new FormControl('', Validators.required),
            medicationFor1: new FormControl(''),
            medicationFor2: new FormControl(''),
            hadPastThoughtsOfEndingLife: new FormControl('', Validators.required),
            everAttemptedToEndYourLife: new FormControl(''),
            consideredHarmingYourselfOrOthers: new FormControl('', Validators.required),
            haveFamilySupport: new FormControl('', Validators.required),
        });

        this.myForm.controls.prescribedMedication.valueChanges.subscribe(checkedValue => {
            if (checkedValue) {
                this.myForm.controls.medicationFor1.setValidators(Validators.required);
                this.myForm.controls.medicationFor1.markAsUntouched({ onlySelf: true });
                this.myForm.controls.medicationFor1.updateValueAndValidity();
            }
            else {
                this.myForm.controls.medicationFor1.setValidators(null);
                this.myForm.controls.medicationFor1.updateValueAndValidity();
            }
        });

        this.myForm.controls.hadPastThoughtsOfEndingLife.valueChanges.subscribe(checkedValue => {
            if (checkedValue) {
                this.myForm.controls.everAttemptedToEndYourLife.setValidators(Validators.required);
                this.myForm.controls.everAttemptedToEndYourLife.markAsUntouched({ onlySelf: true });
                this.myForm.controls.everAttemptedToEndYourLife.updateValueAndValidity();
            }
            else {
                this.myForm.controls.everAttemptedToEndYourLife.setValidators(null);
                this.myForm.controls.everAttemptedToEndYourLife.updateValueAndValidity();
            }
        });
    }

    onSubmit(value: string) {
        if (this.myForm.valid) {
            if (this.signupService.isClientAccessmentAccepted()) {
                //navigate to Client Profile
                this.router.navigateByUrl('/signup-3');
            }
            else {
                this.router.navigateByUrl('/signup-2-not-suitable')
            }
        }
        else {
            this.markAsTouched(this.myForm);
        }
    }

}